import React, { FC, useState } from 'react'
import { FetchQRStatus } from '@entities/payment'
import { closeIosFilePreview, downloadBase64AsFile, openIosFilePreview } from '@shared/lib/file'
import { Button } from '@shared/ui/molecules'
import { OperationDetailsRs } from '@root/api/ump-ewallet'
import { useGetPdf } from '../lib/useGetPdf'

interface DownloadReceiptButtonProps {
  payStatus: string
  receiptData?: Record<string, unknown>[]
  qrStatusData?: FetchQRStatus
  formattedDate?: string
  operationDetails?: OperationDetailsRs
  title?: string
}

const DownloadReceiptButton: FC<DownloadReceiptButtonProps> = ({
  payStatus,
  receiptData,
  qrStatusData,
  formattedDate,
  operationDetails,
  title,
}) => {
  const { handleGetPdf } = useGetPdf({ payStatus, receiptData, qrStatusData, formattedDate, operationDetails })
  const [isLoading, setIsLoading] = useState(false)

  const handleLoadPdf = () => {
    if (isLoading) return

    // Safari на iOS забывает жест пользователя после ответа сервера и блокирует скачивание.
    const previewWindow = openIosFilePreview()

    setIsLoading(true)

    handleGetPdf()
      .then((res) => {
        if (!res?.file) {
          closeIosFilePreview(previewWindow)

          return
        }

        downloadBase64AsFile(res.file, {
          ext: 'pdf',
          filename: `Чек от ${formattedDate}`,
          targetWindow: previewWindow,
        })
      })
      .catch(() => {
        closeIosFilePreview(previewWindow)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  // return <NoticeButton title={title || 'Скачать чек'} icon={<ReceiptIcon />} onClick={handleLoadPdf} />
  return (
    <Button variant="tertiary" disabled={!qrStatusData} isLoading={isLoading} onClick={handleLoadPdf}>
      {title || 'Скачать чек'}
    </Button>
  )
}

export default DownloadReceiptButton
